import { createContext } from 'react'

const manifestContext = createContext()

export default manifestContext
